





import Vue from 'vue';
import { firebase } from 'mostra';

export default Vue.extend({
  name: 'linking',
  async created() {
    try {
      const url = this.$route.query?.url as string;
      const token = this.$route.query?.token as string;
      if (this.$auth.isAnonymous) {
        await firebase
          .auth()
          .signInWithCustomToken(token);
      }
      window.location.href = url;
    } catch (error: any) {
      this.$error('ログインに失敗しました。', error);
      window.location.href = '/web/auth/signin';
    } finally {
      this.$loading(false);
    }
  },
});
